import { render } from "./TradingView.vue?vue&type=template&id=5dd911b9&scoped=true"
import script from "./TradingView.vue?vue&type=script&lang=js"
export * from "./TradingView.vue?vue&type=script&lang=js"

import "./TradingView.vue?vue&type=style&index=0&id=5dd911b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd911b9"]])

export default __exports__